import React, { useState } from 'react';
import './listaDocumento.css';
import axios from 'axios';
import verificandoToken from '../../../FuncoesGerais/VerificarToken';
import { ensureProtocol } from '../../../config/backend';

function ListaDocumento({ arrayDocumento = [], onEdit, onDeleteSuccess }) {
    const [excluindo, setExcluindo] = useState(null);

    const payloadBase64 = (str) => {
        if (!str || typeof str !== 'string') return '';
        const s = str.trim().replace(/\s/g, '');
        const idx = s.indexOf('base64,');
        return idx >= 0 ? s.substring(idx + 7) : s;
    };

    const pareceBase64 = (s) => {
        if (!s || typeof s !== 'string' || s.length < 4) return false;
        return /^[A-Za-z0-9+/]+=*$/.test(s) && s.length % 4 === 0;
    };

    const base64ToBlob = (base64Data) => {
        if (!base64Data) return null;
        const raw = payloadBase64(base64Data);
        if (!raw) return null;
        let decoded = atob(raw);
        if (pareceBase64(decoded)) {
            try {
                decoded = atob(decoded);
            } catch (_) {

            }
        }
        const byteCharacters = decoded;
        const byteNumbers = new Uint8Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        let mimeType = 'application/octet-stream';
        if (typeof base64Data === 'string' && base64Data.startsWith('data:') && base64Data.indexOf(';') > 0) {
            mimeType = base64Data.split(';')[0].split(':')[1];
        }
        return new Blob([byteNumbers], { type: mimeType });
    };

    const downloadFile = (nome, arquivo) => {
        try {
            const data = typeof arquivo === 'string' ? arquivo : '';
            const blob = base64ToBlob(data);
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = nome || 'documento';
            link.click();
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Erro ao fazer download:', error);
        }
    };

    const deleteDocumento = async (seqDoc) => {
        if (!window.confirm('Excluir este documento?')) return;
        verificandoToken();
        const token = localStorage.getItem('token');
        setExcluindo(seqDoc);
        try {
            await axios.delete(ensureProtocol(localStorage.getItem('ipBackend2')) + '/documentos', {
                headers: { Authorization: token },
                data: { seqDoc }
            });
            if (typeof onDeleteSuccess === 'function') onDeleteSuccess();
        } catch (error) {
            console.error('Erro ao excluir:', error);
        } finally {
            setExcluindo(null);
        }
    };

    return (
        <table className="table table-modern align-middle">
            <thead>
                <tr>
                    <th scope="col">Sequência</th>
                    <th scope="col">Descrição</th>
                    <th scope="col">Documento</th>
                    <th scope="col" className="col-acao" />
                    <th scope="col" className="col-acao" />
                    <th scope="col" className="col-acao" />
                </tr>
            </thead>
            <tbody>
                {arrayDocumento.length === 0 && (
                    <tr>
                        <td colSpan="6" className="text-center text-muted">Nenhum documento. Use &quot;Inserir Documento&quot; para adicionar.</td>
                    </tr>
                )}
                {arrayDocumento.map((doc) => (
                    <tr
                        key={doc.id}
                        className="table-row-clickable"
                        onClick={() => typeof onEdit === 'function' && onEdit(doc)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && typeof onEdit === 'function' && onEdit(doc)}
                    >
                        <td>{doc.sequencia}</td>
                        <td>{doc.descricao}</td>
                        <td>{doc.nome}</td>
                        <td onClick={(e) => e.stopPropagation()}>
                            <button className="btn btn-secondary btn-sm" onClick={() => downloadFile(doc.nome, doc.arquivo)} type="button">Download</button>
                        </td>
                        <td onClick={(e) => e.stopPropagation()}>
                            {typeof onEdit === 'function' && (
                                <button className="btn btn-secondary btn-sm" onClick={() => onEdit(doc)} type="button" title="Editar"><i className="fas fa-edit icone-acao" /></button>
                            )}
                        </td>
                        <td onClick={(e) => e.stopPropagation()}>
                            <button className="btn btn-danger btn-sm" onClick={() => deleteDocumento(doc.sequencia)} type="button" disabled={excluindo === doc.sequencia} title="Excluir">
                                <i className="fas fa-trash" aria-hidden="true" />
                            </button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}

export default ListaDocumento;
